import styled from 'styled-components';
import SkeletonLoader from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Skeleton = styled(SkeletonLoader).attrs(props => ({
  containerClassName: props.className,
}))`
  display: flex;
  align-self: center;
  && {
    background: ${props =>
      props.baseColor ? props.baseColor : props.theme.skeletonBaseColor};
  }
`;

export default Skeleton;
